// extracted by mini-css-extract-plugin
module.exports = {"container":"VerifyEmail__container___X0FTy"};